var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconValetKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6666 4.66667H13.925C12.9683 1.94833 10.3783 0 7.33331 0C3.47165 0 0.333313 3.13833 0.333313 7C0.333313 10.8617 3.47165 14 7.33331 14C10.3783 14 12.9683 12.0517 13.925 9.33333H14.3333L16.6666 11.6667L19 9.33333L21.3333 11.6667L26 6.95333L23.6666 4.66667ZM7.33331 10.5C5.40831 10.5 3.83331 8.925 3.83331 7C3.83331 5.075 5.40831 3.5 7.33331 3.5C9.25831 3.5 10.8333 5.075 10.8333 7C10.8333 8.925 9.25831 10.5 7.33331 10.5Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconValetKey);
export default __webpack_public_path__ + "static/media/icon-valet-key.8d75767d95a6496c048d67d206a5ca74.svg";
export { ForwardRef as ReactComponent };